import { Box, Button, useTheme } from '@mui/material'
import React from 'react'
import sizeFontCustom from "../Discovery/fontSize.styles"
import { useTranslation } from '../../hooks/useTranslation'
import { getEntityThemedCtaInlineStyle } from '../../utils/ctaContrast.utils'

function CancelConsent({handleCancel, handleDeny, customDetails}) {
  const { t } = useTranslation();
  const theme = useTheme();
  const errorColor = theme.palette.error.main;
  const isDarkTheme = customDetails?.darkTheme === true;

  return (
        <Box sx={{ display: { xs: "flex" }, marginTop:"1rem" }}>
          <Button
            variant='text' 
            color='error' 
            onClick={handleDeny}
            sx={{
              width: "80%",
              height: "2rem",
              textTransform: "none",
              fontWeight: 600,
              marginRight:"1rem",
              ...sizeFontCustom.heading,
              borderRadius: customDetails?.borderRadius,
              backgroundColor: isDarkTheme ? 'transparent !important' : '#ffffff !important',
              color: `${errorColor} !important`,
              borderColor: `${errorColor} !important`,
              '&:hover': {
                backgroundColor: 'rgba(198, 40, 40, 0.04) !important',
                borderColor: `${errorColor} !important`,
              },

            }}
          >
            {t('common.buttons.yesExit')}
          </Button>
          <Box
            component="button"
            type="button"
            onClick={handleCancel}
            style={getEntityThemedCtaInlineStyle(customDetails, isDarkTheme, {
              width: '80%',
              height: '2rem',
              borderRadius: customDetails?.borderRadius || '6px',
              border: 'none',
              cursor: 'pointer',
              fontFamily: customDetails?.fontFamily,
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: 'none',
            })}
          >
            {t('common.buttons.goBack')}
          </Box>
          
    </Box>  )
}

export default CancelConsent
